import {
  Box,
  Button,
  Typography,
} from '@mui/material'
import { useSelector } from '@xstate/react'
import mixpanel from 'mixpanel-browser'
import { useContext } from 'react'

import styles from 'src/components/Lmn/Lmn.scss'
import { LmnContext } from 'src/components/Dialogs/Lmn/LmnDialog'
import { CDN_PATH } from 'src/constants/global'
import { getLmnMerchantName } from 'src/helpers/lmnHelpers'

const LmnDoesNotQualify = (): JSX.Element => {
  const { lmnContextService } = useContext(LmnContext)
  const { send } = lmnContextService
  const merchantName = useSelector(lmnContextService, getLmnMerchantName)

  const handleReturnToMerchantClicked = (): void => {
    mixpanel.track('lmn_not_qualified_return_to_merchant_clicked')
    send('ON_CANCEL')
  }
  return (
    <Box display="flex" flexDirection="column" gap="12px" alignItems="center" paddingTop="10px">
      <img src={`${CDN_PATH}/images/asset-lmn-icon-not-qualified.svg`} alt="Not qualified icon" height="40" />
      <Typography variant="h4Bold" color="primary.main" marginTop="10px">
        We&apos;re sorry
      </Typography>
      <Typography variant="body3" color="gray1.main" textAlign="center">
        Based on your answers, we can&apos;t provide a Letter of Medical Necessity at this time.
        You can still complete your purchase with another form of payment.
      </Typography>
      <Button
        className={styles.lmnButton}
        color="primary"
        fullWidth
        size="large"
        variant="contained"
        onClick={handleReturnToMerchantClicked}
      >
        <Typography variant="body2Bold">
          Return to
          {' '}
          {merchantName}
        </Typography>
      </Button>
    </Box>
  )
}

export default LmnDoesNotQualify
